import { CompanySelectorNirvanaDataProvider } from '../dataProvider/CompanySelectorNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ, API_TYPE_NIRVANA } from '../../webcomponents.constants';
import { CompanySelectorGzDataProvider } from '../dataProvider/CompanySelectorGzDataProvider';

export class CompanySelectorDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, CompanySelectorNirvanaDataProvider);
    this.map.set(API_TYPE_GZ, CompanySelectorGzDataProvider);
  }
}
